import {
  requestResetPassword,
  resetPassword,
  signInWithCredentials,
} from "@/api/authNew";
import { appConfig } from "@/config/app";
import { useRouter } from "@/i18n/routing";
import { useCreatePasskeyStore } from "@/stores/CreatePasskeyStore";
import { getAuthRedirectPath } from "@/utils/navigation";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { toast } from "sonner";
import { publishSessionLogin } from "@/utils/sessionLogin";

const triggerPasskeyPrompt = (userId: number) => {
  useCreatePasskeyStore.getState().open(userId);
};

export const useCredentialsSignIn = () => {
  const router = useRouter();
  const locale = useLocale();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: signInWithCredentials,
    onSuccess(auth) {
      queryClient.clear();
      triggerPasskeyPrompt(auth.user.id);
      // Sibling tabs parked on sign-in pick the new session up right away.
      publishSessionLogin({ now: new Date() });
      // Always land on the role's home page, regardless of any deep link the
      // user arrived from — no post-login "redirect" bounce.
      const entryPath = getAuthRedirectPath(auth);
      router.replace(entryPath, { locale });
      router.refresh();
    },
  });
};

export const useRequestResetPassword = () => {
  return useMutation({
    mutationFn: requestResetPassword,
    onSuccess(res) {
      if (res.message) toast(res.message);
    },
  });
};

export const useResetPassword = () => {
  const router = useRouter();
  const locale = useLocale();

  return useMutation({
    mutationFn: resetPassword,
    onSuccess(res) {
      if (res.message) toast(res.message);
    },
    onSettled() {
      router.replace(appConfig.unauthenticatedEntry, { locale });
    },
  });
};
